export function route(pageContext: Vike.PageContext) {
  const match = pageContext.urlPathname.match(
    /^(\/archive)(?:(?:\/sport)?\/(all|ras|cfb|cbb|nfl|wnba|nba|ufl|cbase|cfl|bt|plus|[0-9]+))?(?:\/season\/(last-[0-9]|last|current|all-time|[0-9]+)(?:--\/[a-zA-Z0-9-_]+)?)?/,
  );

  if (!match) {
    return false;
  }

  const [, baseUrl, sportId, seasonId] = match;

  const routeParams = {
    baseUrl,
    sportId: sportId === 'bt' ? 'plus' : sportId, // temp migration
    seasonId: seasonId || 'current',
  };

  for (const key in routeParams) {
    if (routeParams[key as keyof typeof routeParams] === undefined) {
      delete routeParams[key as keyof typeof routeParams];
    }
  }

  return { routeParams };
}
